import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-progress-spinner',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss',
})
export class ProgressSpinnerComponent implements OnInit, OnDestroy {
  pagePortal: ComponentPortal<any>;
  overlayRef: OverlayRef;
  loadingState = false;
  private loadingSubscription: Subscription | undefined;

  @Input() set loading(value: boolean) {
    this.loadingState = value;
  }

  constructor(
    public loadingService: LoadingService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // Subscribe to loading state and manually trigger change detection
    this.loadingSubscription = this.loadingService.loading$.subscribe(
      (state) => {
        this.loadingState = state;
        // Manually trigger change detection to ensure UI updates immediately
        this.cdr.detectChanges();
      },
    );
  }

  ngOnDestroy() {
    // Clean up subscription to prevent memory leaks
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
